// src/components/LegalNoticePage.js

import React from 'react';
import './LegalPages.css'; // Common CSS for all legal pages

const LegalNoticePage = ({ isEnglish }) => {
  if (isEnglish) {
    return (
      <div className="legal-page-container">
        <h1>Legal Notice based on the Specified Commercial Transactions Act</h1>
        {/* ▼▼▼ PLEASE REPLACE THIS SECTION WITH YOUR OFFICIAL ENGLISH TRANSLATION ▼▼▼
          The English text provided previously was incorrect.
        */}
        <div className="table-container">
          <table>
            <tbody>
              <tr>
                <th>Company Name</th>
                <td>KICKs Inc. (<a href="https://kanko-innovation.com/" target="_blank" rel="noopener noreferrer">HP</a>)</td>
              </tr>
              <tr>
                <th>Representative</th>
                <td>Kento Yamamoto, Representative Director</td>
              </tr>
              <tr>
                <th>Address</th>
                <td>#402 Dai-2 Kyoto Bldg., 227 Daikoku-cho, Shimogyo-ku, Kyoto, 600-8223, Japan</td>
              </tr>
              {/* Add other translated items here */}
              <tr>
                <th>Contact</th>
                <td>Kanazawa Stay Akebono<br />Email: info@kanazawa-akebono.com</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* ▲▲▲ END OF SECTION TO BE REPLACED ▲▲▲ */}
      </div>
    );
  }

  return (
    <div className="legal-page-container">
      <h1>特定商取引法に基づく表記</h1>
      <div className="table-container">
        <table>
          <tbody>
            <tr>
              <th>会社名</th>
              <td>株式会社KICKs (<a href="https://kanko-innovation.com/" target="_blank" rel="noopener noreferrer">HP</a>)</td>
            </tr>
            <tr>
              <th>代表者</th>
              <td>代表取締役 山本 健人</td>
            </tr>
            <tr>
              <th>所在地</th>
              <td>〒600-8223 京都府京都市下京区大黒町２２７番地第２キョートビル４０２</td>
            </tr>
            <tr>
              <th>運営責任者</th>
              <td>山本 健人</td>
            </tr>
            <tr>
              <th>価格</th>
              <td>予約時に提示致します。または、予約サイトよりご確認下さい。</td>
            </tr>
            <tr>
              <th>代金清算方法</th>
              <td>オンライン予約完了時にクレジットカードにてお支払い</td>
            </tr>
            <tr>
              <th>商品引渡し期限<br />（予約の成立）</th>
              <td>当サイトを利用してご宿泊予約をされる場合は、予約完了のご案内がお客様画面上に表示された時点でご予約の成立となります。<br />尚、クレジットカードにて事前清算の場合は、クレジット決済が完了した時点でご予約の成立となります。</td>
            </tr>
            <tr>
              <th>返品</th>
              <td>商品及びサービスの特性上、ご宿泊利用後における返品は出来かねます。内容を十分ご確認の上、お申し込み下さい。</td>
            </tr>
            <tr>
              <th>キャンセル料</th>
              <td>予約時に提示致します。または、予約サイトよりご確認下さい。</td>
            </tr>
            <tr>
              <th>お問合せ先</th>
              <td>金沢之旅宿 あけぼの<br />Email: info@kanazawa-akebono.com</td>
            </tr>
            <tr>
              <th>事業者</th>
              <td>株式会社KICKs</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LegalNoticePage;